export default "__VITE_ASSET__yJCtBWkT__"